import { Directive, OnInit } from '@angular/core';
import confetti from 'canvas-confetti';

@Directive({
  selector: 'amfam-confetti',
  standalone: false
})
export class ConfettiDirective implements OnInit {
  ngOnInit(): void {
    setTimeout(() => {
      this.celebrate();
    }, 0);
  }

  celebrate() {
    confetti({
      particleCount: 100,
      spread: 100,
      origin: { y: 0.6 }
    });
  }
}
